import React from 'react';

import * as Headers from 'ui-library/Headers';

export default function HeaderGuidelines(): JSX.Element {
  return (
    <div className="u-padding">
      <Headers.Header1>Headers</Headers.Header1>
      <a href="https://zpl.io/Z1PyDS2">https://zpl.io/Z1PyDS2</a>
      <div className="u-large-spacing-top">
        Below are the currently available Header styles (not all from the guidelines have been implemented):
      </div>
      <hr />
      <Headers.Header1>Header1</Headers.Header1>
      <hr />
      <Headers.Header2>Header2</Headers.Header2>
      <hr />
      <Headers.Header3>Header3</Headers.Header3>
      <hr />
      <Headers.Title>Title</Headers.Title>
      <hr />
    </div>
  );
}
